!function() {
  "use strict";

  // Configuration & Selectors
  const POPUP_COMPONENT = "popup-component";
  const CLOSE_BTN = "[data-popup-close]";
  const FORM_SELECTOR = "[data-notification-form]";
  const HEADING_SELECTOR = "[data-product-notification-heading]";
  const SUCCESS_CLASS = "has-success";
  const HIDDEN_CLASS = "hidden";

  // Klaviyo Setup
  const KLAVIYO_PUBLIC_KEY = "TgGkvv";
  const VARIANT_NAMESPACE = "$shopify:::$default:::";

  if (!customElements.get("product-notification")) {
    customElements.define("product-notification", class extends HTMLElement {
      constructor() {
        super();
        this.notificationForm = this.querySelector(FORM_SELECTOR);
        this.heading = this.querySelector(HEADING_SELECTOR);
        this.popup = this.closest(POPUP_COMPONENT) || this.closest("dialog");
        this.popupClose = this.popup ? this.popup.querySelector(CLOSE_BTN) : null;
        this.submitBtn = this.notificationForm ? this.notificationForm.querySelector('[type="submit"]') : null;
      }

      connectedCallback() {
        if (this.notificationForm) {
          this.notificationForm.addEventListener("submit", (e) => this.handleKlaviyoSubmit(e));
        }
      }

      async handleKlaviyoSubmit(event) {
        event.preventDefault();

        const formData = new FormData(this.notificationForm);
        
        // Extract Email
        const email = formData.get("contact[email]") || formData.get("email");
        
        // Extract Variant ID (Fallback from hidden input -> dataset attribute -> element dataset)
        const rawVariantId = 
          formData.get("variant_id") || 
          formData.get("id") || 
          this.notificationForm.getAttribute("data-variant-id") || 
          this.notificationForm.dataset.variantId;

        if (!email || !rawVariantId) {
          console.error("Klaviyo BIS Error: Missing email or variant ID.", { email, rawVariantId });
          return;
        }

        const klaviyoVariantId = `${VARIANT_NAMESPACE}${rawVariantId}`;

        if (this.submitBtn) this.submitBtn.disabled = true;

        try {
          const response = await fetch(
            `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${KLAVIYO_PUBLIC_KEY}`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                "revision": "2024-02-15"
              },
              body: JSON.stringify({
                data: {
                  type: "back-in-stock-subscription",
                  attributes: {
                    channels: ["EMAIL"],
                    profile: {
                      data: {
                        type: "profile",
                        attributes: {
                          email: email
                        }
                      }
                    }
                  },
                  relationships: {
                    variant: {
                      data: {
                        type: "catalog-variant",
                        id: klaviyoVariantId
                      }
                    }
                  }
                }
              })
            }
          );

          if (response.ok || response.status === 202) {
            this.handleSuccess();
          } else {
            const errorPayload = await response.json().catch(() => ({}));
            console.error("Klaviyo Back-in-Stock API Error:", response.status, errorPayload);
          }
        } catch (error) {
          console.error("Network error during Back in Stock subscription:", error);
        } finally {
          if (this.submitBtn) this.submitBtn.disabled = false;
        }
      }

      handleSuccess() {
        if (this.heading) {
          this.heading.classList.add(HIDDEN_CLASS);
        }

        if (this.notificationForm) {
          this.notificationForm.classList.add(HIDDEN_CLASS);
        }

        const parentPopup = this.closest(POPUP_COMPONENT) || this;
        parentPopup.classList.add(SUCCESS_CLASS);
      }
    });
  }
}();